import { UltimateGenerateRequestPromptLanguageEnum } from '@models/Sessions/Idea/podcast-api';

export const promptLanguages: Record<
  UltimateGenerateRequestPromptLanguageEnum,
  { flag: string; label: string }
> = {
  en: {
    flag: '🇬🇧',
    label: 'English',
  },
  de: {
    flag: '🇩🇪',
    label: 'Deutsch',
  },
};
